import { buildAxonItem, pushAxonEvent } from '@/utils/axonTrack'

export function useAxonViewItem() {
  const reportedMethods = new Set<number>()

  function reportViewItem(
    products: any[],
    currentPaymentMethod: number,
    itemName: 'Coins Package' | 'Membership',
    getPrice: (p: any) => string | number = p => p.price,
    // 充值商品带 payConfigId,订阅商品带 subscribeConfigId,默认访问器两者兼容
    getConfigId: (p: any) => string | number | undefined = p => p.payConfigId ?? p.subscribeConfigId,
  ) {
    if (!products.length)
      return
    if (reportedMethods.has(currentPaymentMethod))
      return

    reportedMethods.add(currentPaymentMethod)
    pushAxonEvent('view_item', {
      currency: 'USD',
      items: products.map(p => buildAxonItem(getConfigId(p), p.productId, itemName, getPrice(p))),
    })
  }

  return { reportViewItem }
}
